// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {useContext} from 'react';
import {
    Form_content_ctx,
    Form_controls_ctx,
    Form_validity_ctx,
} from './contexts.js';
import {pick_value} from './utils.js';

export function use_validity(field){
    const content = useContext(Form_validity_ctx);
    return content[field];
}

export function use_controls(){
    return useContext(Form_controls_ctx);
}

export function use_value(field, default_val=''){
    const content = useContext(Form_content_ctx);
    return pick_value(content, field, default_val);
}
